/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const updateAdDataSchema = z.object({
	target: z.string(),
	cta: z.string(),
	location: z.string(),
	metaCallToAction: z.string(),
	metaDescription: z.string(),
	metaHeadline: z.string(),
	metaPrimaryText: z.string(),
	subtitle: z.string(),
	title: z.string(),
	meta: z.record(z.string(), z.unknown()).nullable().optional(),
})

export type UpdateAdDataSchema = z.infer<typeof updateAdDataSchema>
